import React, { Suspense } from "react";

interface SuspenseWrapperProps {
    path: string;
}

export const SuspenseWrapper = (props: SuspenseWrapperProps) => {
    const LazyComponent = React.lazy(() => import(`../../${props.path}`));

    return (
        <Suspense
            fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <p>Loading</p>
                    </div>
                </div>
            }
        >
            <LazyComponent />
        </Suspense>
    );
};

export default SuspenseWrapper;
